module.exports = __webpack_public_path__ + "static/idiya-5681177408fef55e670eaf70dd6ee771.png";